import { render, staticRenderFns } from "./sync-console-tabs-nav.vue?vue&type=template&id=feb12d9a&scoped=true&"
import script from "./sync-console-tabs-nav.vue?vue&type=script&lang=ts&"
export * from "./sync-console-tabs-nav.vue?vue&type=script&lang=ts&"
import style0 from "./sync-console-tabs-nav.vue?vue&type=style&index=0&id=feb12d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb12d9a",
  null
  
)

export default component.exports